import { motion } from "framer-motion";
import { Settings } from "lucide-react";
import { useState } from "react";

export function SettingsButton({
  className,
  onClick,
  theme = "dark",
}: {
  className?: string;
  onClick?: () => void;
  theme?: "dark" | "light";
}) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.button
      aria-label="Settings"
      className={`amicro-settings-button amicro-settings-button--${theme}${className ? ` ${className}` : ""}`}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      whileTap={{ scale: 0.96 }}
      type="button"
    >
      <span className="amicro-settings-button__icon" aria-hidden="true">
        <motion.span
          animate={{ rotate: isHovered ? 180 : 0 }}
          transition={{ type: "spring", stiffness: 400, damping: 25 }}
        >
          <Settings aria-hidden="true" size={16} />
        </motion.span>
      </span>
      <span className="amicro-settings-button__label">Settings</span>
    </motion.button>
  );
}
